const isIOS26Plus = () => {
  const userAgent = window.navigator.userAgent;
  const isIOS = /iPad|iPhone|iPod/.test(userAgent);
  if (!isIOS) return false;
  
  const safariVersionMatch = userAgent.match(/Version\/(\d+)\.(\d+)/);
  if (safariVersionMatch) {
    const safariMajorVersion = parseInt(safariVersionMatch[1]);
    return safariMajorVersion >= 26;
  }
  return false;
};

if (isIOS26Plus()) {
    document.body.classList.add('ios-26-plus');
}